import { i18nTranslationHelper } from '@/i18n'

const t = i18nTranslationHelper.getTEnums

export namespace PreferredContentType {
  export class Enum {
    static readonly COURSE = new Enum(
      'COURSE',
      t('preferredContentType.COURSE.name'),
      t('preferredContentType.COURSE.description'),
      t('preferredContentType.COURSE.averageDuration')
    )

    static readonly TECHNICAL = new Enum(
      'TECHNICAL',
      t('preferredContentType.TECHNICAL.name'),
      t('preferredContentType.TECHNICAL.description'),
      t('preferredContentType.TECHNICAL.averageDuration')
    )

    static readonly HIGH_SCHOOL = new Enum(
      'HIGH_SCHOOL',
      t('preferredContentType.HIGH_SCHOOL.name'),
      t('preferredContentType.HIGH_SCHOOL.description'),
      t('preferredContentType.HIGH_SCHOOL.averageDuration')
    )

    static readonly UNDERGRADUATE = new Enum(
      'UNDERGRADUATE',
      t('preferredContentType.UNDERGRADUATE.name'),
      t('preferredContentType.UNDERGRADUATE.description'),
      t('preferredContentType.UNDERGRADUATE.averageDuration')
    )

    static readonly GRADUATE = new Enum(
      'GRADUATE',
      t('preferredContentType.GRADUATE.name'),
      t('preferredContentType.GRADUATE.description'),
      t('preferredContentType.GRADUATE.averageDuration')
    )

    static readonly SUBSCRIPTION = new Enum(
      'SUBSCRIPTION',
      t('preferredContentType.SUBSCRIPTION.name'),
      t('preferredContentType.SUBSCRIPTION.description'),
      t('preferredContentType.SUBSCRIPTION.averageDuration'),
      true
    )

    static readonly LANGUAGE = new Enum(
      'LANGUAGE',
      t('preferredContentType.LANGUAGE.name'),
      t('preferredContentType.LANGUAGE.description'),
      t('preferredContentType.LANGUAGE.averageDuration')
    )

    public constructor(
      public readonly key: string,
      public readonly name: string,
      public readonly description: string,
      public readonly averageDuration: string,
      public readonly isSubType: boolean = false
    ) {}

    public toRemote() {
      return this.isSubType
        ? {
            subType: this.key
          }
        : {
            type: this.key
          }
    }
  }

  export const getAll = (userEducationLevelId: number): Enum[] =>
    Object.values(Enum).filter(
      item => item.key !== 'HIGH_SCHOOL' || !userEducationLevelId || userEducationLevelId <= 1
    )

  export const getByKey = (key: string): Enum => Object.values(Enum).find(item => key == item.key)

  export const getByTypeAndSubType = (type: string | null, subType: string | null): Enum =>
    Object.values(Enum).find(
      item =>
        (type && item.key === type && !item.isSubType) ||
        (subType && item.key === subType && item.isSubType)
    )
}
